var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_717_20230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8C20.05 8 19.24 9.44 19.57 10.51L16.02 14.07C15.72 13.98 15.28 13.98 14.98 14.07L12.43 11.52C12.77 10.45 11.96 9 10.5 9C9.05 9 8.23 10.44 8.57 11.52L4.01 16.07C2.94 15.74 1.5 16.55 1.5 18C1.5 19.1 2.4 20 3.5 20C4.95 20 5.76 18.56 5.43 17.49L9.98 12.93C10.28 13.02 10.72 13.02 11.02 12.93L13.57 15.48C13.23 16.55 14.04 18 15.5 18C16.95 18 17.77 16.56 17.43 15.48L20.99 11.93C22.06 12.26 23.5 11.45 23.5 10C23.5 8.9 22.6 8 21.5 8Z",
    fill: "#261B71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9L16.44 6.93L18.5 6L16.44 5.07L15.5 3L14.58 5.07L12.5 6L14.58 6.93L15.5 9Z",
    fill: "#261B71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11L4.5 9L6.5 8.5L4.5 8L4 6L3.5 8L1.5 8.5L3.5 9L4 11Z",
    fill: "#261B71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_20230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.d457bc2bcf3366ab2d0df76e49b5a69d.svg";
export { ForwardRef as ReactComponent };